<button
  type="button"
  class="pill"
  [class.pill--lg]="size === 'lg'"
  [class.on]="active"
  [attr.aria-pressed]="active"
  (click)="onClick()"
>
  <span
    class="pill-label"
    [matTooltip]="label"
    matTooltipPosition="above"
    appTruncateTooltip
    >{{ label }}</span
  >
  <mat-icon *ngIf="showCheck && active" class="pill-check">check</mat-icon>
</button>
